//Sub menus
export const Show_Meeting_Submenu = "Show_Meeting_Submenu";
export const Clear_Meeting_Submenu = "Clear_Meeting_Submenu";

//Breadcrumbs
export const Add_BreadCrumb = "Add_BreadCrumb";
export const Replace_And_Add_BreadCrumb = "Replace_And_Add_BreadCrumb";
export const Clear_All_BreadCrumb = "Clear_All_BreadCrumb";

export const SET_USER_DATA = "SET_USER_DATA";

//Activities Types
export const GET_ACTIVITY_TYPE = "GET_ACTIVITY_TYPE";
export const GET_ACTIVITY_TYPES = "GET_ACTIVITY_TYPES";
export const ACTIVITY_TYPES_LOADING = "ACTIVITY_TYPES_LOADING";
export const ACTIVITY_TYPES_ERROR = "ACTIVITY_TYPES_ERROR";
export const ACTIVITY_TYPE_ERROR = "ACTIVITY_TYPE_ERROR";
export const EDIT_ACTIVITY_TYPE = "EDIT_ACTIVITY_TYPE";


//Contacts 
export const GET_AllContacts = "GET_Contact";
export const GET_AllContacts_ERROR = "GET_Contact_ERROR";
export const GET_Contacts = "GET_ContactS";
export const Contacts__LOADING = "ContactS__LOADING";
export const Contacts_ERROR = "ContactS_ERROR";
export const EDIT_Contact = "EDIT_Contact";
export const Get_Contact_BelongsTo = "Get_Contact_BelongsTo";


//Companies 
export const GET_AllCompanies = "GET_Companies";
export const GET_AllCompanies_ERROR = "GET_Companies_ERROR";
export const GET_Company = "GET_Company";
export const Companies__LOADING = "Companies__LOADING";
export const Company_ERROR = "Company_ERROR";
export const EDIT_Company = "EDIT_Company";
export const GET_AllGeneralPartners = "GET_AllGeneralPartners";


//Company Group
export const GET_AllCompanyGroups = "GET_CompanyGroups";
export const CompanyGroups__LOADING = "CompanyGroups__LOADING";
export const GET_AllCompanyGroups_ERROR = "GET_CompanyGroups_ERROR";

//Legal Form
export const GET_AllLegalForm = "GET_LegalForm";
export const LegalForm__LOADING = "LegalForm__LOADING";
export const GET_AllLegalForm_ERROR = "GET_LegalForm_ERROR";

// Feature Toggle
export const Feature_Toggle = "Feature_Toggle";
export const Version = "Version";

// Public Action Buttons
export const Add_Public_ActionButtons = "Add_Public_ActionButtons";
